import React from "react";
import auth from "./Auth";

const hasPermission = ({
    permissions,

    scopes,
}: {
    permissions: any;

    scopes: any;
}) => {
    const scopesMap: any = {};

    scopes?.forEach((scope: any) => {
        scopesMap[scope] = true;
    });

    return permissions?.some((permission: any) => scopesMap[permission]);
};
class AuthUtility {

    public hasPermission = (scopes: any) => {
        var token = auth.getPermissions();

        if (token && token !== "{}") {
            let permissions: any = [];

            token?.authorization?.permissions?.map((permission: any) => {
                permissions.push(permission.rsname);

                permission?.scopes?.map((scope: any) => {
                    permissions.push(scope);
                });
            });

            const permissionGranted = hasPermission({
                permissions,
                scopes: scopes,
            });

            return permissionGranted;
        }
    }
}
const authUtility = new AuthUtility();
export default authUtility;